import Flex from 'src/components/Layout/Flex/Flex'
import styled, { css } from 'styled-components'
import { InputFilesGroupProps } from './types'
import { MainWrapper } from 'src/components/Atoms/InputFiles/InputFiles.styles'

export const InputFilesGroupWrapper = styled(Flex)<Pick<InputFilesGroupProps, 'flex' | 'gridArea' | 'margin' | 'width'> & { disabled?: boolean, isDocumentation?: boolean; }>`
    flex-direction: ${props => props.flexDirection || 'column'};
    align-items: ${props => props.alignItems || 'flex-start'};
    width: ${props => props.width ? props.width : (props.maxWidth ? 'auto' : '100%')};
    cursor: ${props => props.isDocumentation ? 'pointer' : 'not-allowed'};
    
    ${props => props.gridArea && css`
        grid-area: ${props.gridArea};
    `}

    ${props => props.margin && css`
        margin: ${props.margin};
    `}


    ${props => {
    const cursorDocStyle = props.isDocumentation ? 'pointer' : 'not-allowed'
    return props.disabled && css`

        ${MainWrapper} {
          background-color: ${props => props.theme.colors.shades.neutral[0]};
          pointer-events: ${props.isDocumentation ? 'auto' : 'none' };

          label, p {
            color:  ${props => props.theme.colors.shades.neutral[5]};
            cursor: ${cursorDocStyle};
          }
        }

        svg {
          cursor: ${cursorDocStyle};
        }

        path {
          fill: ${props => props.theme.colors.shades.neutral[5]};
          cursor: ${cursorDocStyle};
        }
    `}}
`
